import React, { useEffect, useState } from "react";
import DeviceContext from "../Services/identifyDevice";
import Button from "../UI/Button/Button";
import "./VideoVerification.scss";
import VideoPlayerIpv from "../UI/VideoPlayerIpv/VideoPlayerIpv";
import Backdrop from "../UI/Backdrop/Backdrop";
import ipvDemo from "../../assets/icons/ipv_demo.jpg";
import GlobalStore from "../store/globalStore";
import correctIPV from "../../assets/correct-IPV.svg";
import wrongIpvOne from "../../assets/wrong-ipv-one.svg";

import wrongIpvTwo from "../../assets/wrong-ipv-two.svg";

import wrongIpvThree from "../../assets/wrong-ipv-three.svg";
import {
  AGetIpvOtp,
  ASaveIPVerificationDetails,
  ASendSms,
  AUploadIpv,
  AUploadIpvNew,
  AUploadIpvSafari,
} from "../Services/dashboard/ipvApiServices";
import ErrMsg from "../UI/ErrMsg/ErrMsg";
import {
  completeModuleStatus,
  incompleteStageNavigation,
  setStageData,
} from "../Services/globalService";
import { dashboardUrl, watsappNo, geoLocationConfig } from "../utils/constants";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import gtmService from "../Services/gtmService";
import mixpanelService from "../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";
import useQuery from "../../customHooks/useQuery";
import cleverTapEvents from "../../config/cleverTapEvents";
import { ClevertapService } from "../Services/clevertapService";
import { AppsFlyerService } from "../Services/appsFlyerService";
import appsFlyerEvents from "../../config/appsFlyerEvents";
import { AGetClientDetailsByPan, AGetClientDetailsByPanV1 } from "../Services/registration/panDobApiService";
import Toggle from "../UI/Toggle/Toggle";
import watsAppIcon from "../../assets/icons/watsapp.png";
import { AGetStageCompletionStatus } from "../Services/registration/continueApiService";
import config from "../../config/domain";
import useGeoLocation from "../../customHooks/useGeoLocation";
import InfoModal from "../UI/InfoModal/InfoModal";
import { decryptJwtToken } from "../Services/dashboard/encryptionNew";
import { ITokenObj } from "../types/genericTypes";
import { usePageTitle } from '../../hooks/usePageTitle';

export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}
export interface IQueryObject {
  PanNo?: string;
  AccountCategory?: string;
  userid?: number;
  Pan?: string;
  Ac?: string;
  uid?: any;
}
export interface VideoVerificationProps { }

const VideoVerification: React.FC<VideoVerificationProps> = () => {
  usePageTitle('Video Verification');
  // Fetch query params for clervertap
  const queryParams = useQuery();
  const UTM_SOURCE = queryParams.get("utm_source")
    ? queryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = queryParams.get("utm_medium")
    ? queryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = queryParams.get("utm_campaign")
    ? queryParams.get("utm_campaign")
    : "";
  const id: any = queryParams.get("id") ? queryParams.get("id") : "";
  let userId = "0";
  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }
  const [errCode, setErrCode] = React.useState<number | string>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showSample, setShowSample] = React.useState(false);
  const [otp, setOtp] = React.useState<string>("");
  const [enableLink, setEnableLink] = React.useState<boolean>(false);
  const [eSignCompleted, setESignCompleted] = useState(false);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [retryLocation, setRetryLocation] = useState(false);
  // const history = useHistory();
  const navigate = useNavigate()
  let intervalTimer: any;

  const geoLoc: iGeoLocation = useGeoLocation();
  const [isGeoError, setIsGeoError] = React.useState<boolean>(false);
  const [isGeoErrorTimeFlag, setIsGeoErrorTimeFlag] =
    React.useState<boolean>(false);
  const [showBrowserPermissionModal, setsShowBrowserPermissionModal] =
    useState<boolean>(false);
  const [browserPermission, setBrowserPermission] = useState<boolean>(true);
  const [locationPermission, setLocationPermission] = useState<boolean>(true);
  const [cameraPermission, setCameraPermission] = useState<boolean>(true);
  let watchPositionId: number;
  let errorTimer = geoLocationConfig.errorTimer;
  React.useEffect(() => {
    //   getLocation();
    window.sessionStorage.setItem("stageInfoId", "7");
    if (!id) {
      // if(isGeoError && isGeoErrorTimeFlag){
      //   getLocation();
      // }
      AGetIpvOtp(getIpvOtp, GlobalStore.applicationID);
    } else {
      const fixedId = decodeURIComponent(id).replace(/\s/g, "+");

      let panObj: any = atob(fixedId);
      setIsLoading(true);
      if (typeof panObj == "string" && (!panObj?.includes("PanNo") && !panObj?.includes("Pan"))) {
        // AGetClientDetailsByPan(searchByPan, panObj, 1, 0);
        AGetClientDetailsByPanV1(searchByPan, fixedId)
      } else {
        AGetClientDetailsByPanV1(searchByPan, fixedId)
        // if (
        //   panObj?.PanNo !== undefined &&
        //   panObj?.PanNo !== null &&
        //   panObj?.AccountCategory !== null &&
        //   panObj?.AccountCategory !== undefined
        // ) {
        //   AGetClientDetailsByPan(
        //     searchByPan,
        //     panObj?.PanNo,
        //     parseInt(panObj?.AccountCategory),
        //     panObj?.userid
        //   );
        // } else if (
        //   panObj?.Pan !== null &&
        //   panObj?.Pan !== undefined &&
        //   panObj?.Pan !== "" &&
        //   panObj?.Ac !== null &&
        //   panObj?.Ac !== undefined
        // ) {
        //   AGetClientDetailsByPan(
        //     searchByPan,
        //     panObj?.Pan,
        //     parseInt(panObj?.Ac),
        //     panObj?.uid
        //   );
        // }
      }
    }
    if (
      lat !== null &&
      lat !== undefined &&
      lat !== "" &&
      long !== null &&
      long !== undefined &&
      long !== ""
    ) {
    } else {
      console.log("geoLocation", geoLoc, geoLoc?.coordinates);
      if (
        GlobalStore?.location !== null &&
        GlobalStore?.location !== undefined &&
        GlobalStore?.location?.lat !== null &&
        GlobalStore?.location?.lat !== undefined &&
        GlobalStore?.location?.lat !== "" &&
        GlobalStore?.location?.long !== null &&
        GlobalStore?.location?.long !== undefined &&
        GlobalStore?.location?.long !== ""
      ) {
        setLat(GlobalStore?.location?.lat);
        setLong(GlobalStore?.location?.long);
      } else {
        setTimeout(() => {
          watchPositionId = navigator.geolocation.watchPosition(
            successPosition,
            errorPosition
          );
          setIsGeoErrorTimeFlag(true);
        }, errorTimer);
        setIsLoading(true);
      }
    }
  }, []);

  React.useEffect(() => {
    watchPositionId = navigator.geolocation.watchPosition(
      successPosition,
      errorPosition
    );
    if (locationPermission === true && cameraPermission === true) {
      console.log("inside setter ");
      setBrowserPermission(true);
      setsShowBrowserPermissionModal(false);
      setIsGeoError(false);
    } else {
      console.log("inside setter else");
      setBrowserPermission(false);
      setsShowBrowserPermissionModal(true);
      setIsGeoError(true);
    }
    // getLocation();
  }, [geoLoc, locationPermission, cameraPermission]);

  // React.useEffect(() => {
  //     // navigator.geolocation.watchPosition(successPosition, errorPosition)
  // }, [lat, long]);

  // Clervertap event: Profiler/Investment screen is loaded
  React.useEffect(() => {
    const data = {
      EventName: cleverTapEvents.registration.ipvPage.PAGE_LOAD,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      KRA: GlobalStore.isKRA,
      DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
    };

    ClevertapService.pushEvent(data);
  }, []);

  const searchByPan = (res: any) => {
    if (!res || res.error) {
      // setErrCode("118 - Error in fetching Client details from our system.");
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data) {
        if (res.data != null) {
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
        }
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetails(res),
          GlobalStore.applicationID
        );
        AGetIpvOtp(getIpvOtp, GlobalStore.applicationID);
      } else {
        setErrCode("1182 - Error in fetching Client details from our system.");
        setIsLoading(false);
      }
    }
  };

  const getLocation = () => {
    if (geoLoc.loaded && geoLoc.error == false) {
      console.log("I'm here");
      setLat(`${geoLoc.coordinates.lat}`);
      setLong(`${geoLoc.coordinates.lng}`);
    } else {
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(setLocation, errorLocation, {
          enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
          maximumAge: geoLocationConfig.maximumAge,
          timeout: geoLocationConfig.timeout,
        });
        watchPositionId = navigator.geolocation.watchPosition(
          successPosition,
          errorPosition
        );
      }
    }
  };

  const setLocation = (position: { coords: any }) => {
    console.log("Set Location", position.coords);
    setLat(position.coords.latitude);
    setLong(position.coords.longitude);

    geoLoc.coordinates.lat = position.coords.latitude;
    geoLoc.coordinates.lng = position.coords.longitude;
    geoLoc.error = false;
    setIsGeoError(false);
    setIsGeoErrorTimeFlag(false);
    setIsLoading(false);
    console.log("In saveLocation", geoLoc);
  };

  const errorLocation = (err: any) => {
    console.log(`ERROR(${err.code}): ${err.message}`);
    geoLoc.error = true;
    setIsLoading(true);
    setIsGeoError(true);
    // getLocation();
  };

  const iPVerificationSaved = (res: any, isFromSMS?: string) => {
    if (!res || res.error) {
      // setErrCode("Error in saving geo-location details");
      setErrCode(res.error);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR150",
      });
      mixpanelService({
        event: mixpanelEvents.ERROR_TRIGGERED,
        screen_name: getScreenName(window.location.pathname),
        error_object: res.error,
      });
      setIsLoading(false);
    } else {
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR150-S",
      });
      if (isFromSMS == "fromSMS") {
        checkPdStatus();
      } else {
        completeModuleStatus(dashboardUrl.ipv);
        gtmService({ action: "VIDEO_IPV", label: "Step_Complete" });
        // Clevertap event: submit documents data
        const data = {
          EventName: cleverTapEvents.registration.ipvPage.CLICK_ON_SUBMIT,
          InitiationPlatform: "",
          UTM_SOURCE: UTM_SOURCE || "",
          UTM_MEDIUM: UTM_MEDIUM || "",
          UTM_CAMPAIGN: UTM_CAMPAIGN || "",
          KRA: GlobalStore.isKRA,
          DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
          ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
          LEAD_ID: GlobalStore.leadId,
          REF_ID: GlobalStore.applicationID,
        };

        ClevertapService.pushEvent(data);
        // Clevertap ends here

        // Apps flyer event for click on proceed on bank details page
        AppsFlyerService.pushEvent(
          appsFlyerEvents.registration.ipvPage.CLICK_ON_SUBMIT
        );

        if (!id)
          // history.push(incompleteStageNavigation());
          navigate(incompleteStageNavigation())
        else
          alert(
            "IPV uploaded successfully, please close this browser window and continue with your Account Opening process"
          );
      }
    }
  };

  function successPosition(data: any) {
    setIsLoading(false);
    setLocationPermission(true);
    // setBrowserPermission(true);
    // setsShowBrowserPermissionModal(false);
    setLat(data.coords.latitude);
    setLong(data.coords.longitude);
    navigator.geolocation.clearWatch(watchPositionId);
  }

  function saveIpvDetails(data: any) {
    console.log("CALLED HHH");
    console.log("lat", lat);
    console.log("long", long);
    if (lat !== "" && lat !== undefined && long !== "" && long !== undefined) {
      var latitude = lat;
      var longitude = long;
      const ipvObj = {
        leadid: GlobalStore.leadId,
        clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
        applicationid: GlobalStore.applicationID,
        placeofDeclaration: "mumbai",
        empName: "diy user",
        designation: "online rm",
        branch: "mumbai",
        empCode: "0",
        organization: "Nuvama Wealth & investment Ltd",
        organizationCode: "2",
        geo_location: `${latitude}, ${longitude}`,
        ipaddress: "192.168.200.80",
        ipvlink: "",
        latitude: `${latitude}`,
        longitude: `${longitude}`,
        source: "VideoVerification",
        createdBy: parseInt(userId),
      };

      console.log("Called  in success");
      //ASaveIPVerificationDetails(iPVerificationSaved, ipvObj);
      ASaveIPVerificationDetails(
        (response: any) => iPVerificationSaved(response),
        ipvObj
      );
    } else {
      setsShowBrowserPermissionModal(true);
    }
  }

  function errorPosition(data: any) {
    setIsLoading(true);
    setLocationPermission(false);
    // setBrowserPermission(false);
    // setsShowBrowserPermissionModal(true);
    // if (!browserPermission) {
    //   getLocation();
    // }
  }
  async function turnOnCamera() {
    getLocation();

    const constraints = {
      audio: false,
      video: {
        facingMode: "user",
      },
    };

    function handleSuccess(turnOfCamera: MediaStream) {
      console.log("HANDLE success", turnOfCamera);
      // setBrowserPermission(true);
      // setsShowBrowserPermissionModal(false);
      setCameraPermission(true);
      setIsLoading(false);
    }

    function handleError(error: any) {
      console.log("HANDLE ERROR", error);
      setIsLoading(true);
      // setBrowserPermission(false);
      // setsShowBrowserPermissionModal(true);
      setCameraPermission(false);
      console.log("handle error line end");
      // if (!browserPermission) {
      //   turnOnCamera();
      // }
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        console.log(stream, "then");
        handleSuccess(stream);
      })
      .catch((stream) => {
        console.log(stream, "catch");
        handleError(stream);
      });
  }
  function getIpvOtp(res: any) {
    if (!res || res.error) {
      // setErrCode("456 - Error in getting IPV OTP");
      setErrCode(res.error);
      gtmService({ action: "GetIPVOTP", label: "ERROR || ERR149" });
    } else {
      if (res.data && res.data.OTP) {
        setOtp(res.data.OTP);
        if (
          GlobalStore?.location !== null &&
          GlobalStore?.location !== undefined &&
          GlobalStore?.location?.lat !== null &&
          GlobalStore?.location?.lat !== undefined &&
          GlobalStore?.location?.lat !== "" &&
          GlobalStore?.location?.long !== null &&
          GlobalStore?.location?.long !== undefined &&
          GlobalStore?.location?.long !== ""
        ) {
          setLat(GlobalStore?.location?.lat);
          setLong(GlobalStore?.location?.long);
        } else {
          getLocation();
        }
      } else {
        gtmService({ action: "GetIPVOTP", label: "ERROR || ERR149-S" });
      }
    }
    setIsLoading(false);
  }

  function ipvUploaded(uploadObj: any, isSafari: boolean) {
    console.log("lat", lat);
    console.log("long", long);
    if (lat !== "" && lat !== undefined && long !== "" && long !== undefined) {
      console.log("uploadObj", uploadObj);
      let imageData: Array<any> = [];
      // if(Array.isArray(uploadObj?.))
      let uploadNewObj: any = {
        image64:
          uploadObj?.image64 !== null &&
            uploadObj?.image64 !== undefined &&
            uploadObj?.image64?.length > 0
            ? uploadObj?.image64
            : [uploadObj?.image],
        clientPrimaryDetailId: uploadObj?.clientprimarydetailid,
        applicationId: uploadObj?.applicationid,
        leadId: uploadObj?.leadId,
        panNo: uploadObj?.panno,
        width: 0,
        height: 0,
        imageToVideo: false,
        imageName: uploadObj.imageName,
        contentType: uploadObj.contentType,
      };
      setIsLoading(true);
      if (isSafari) {
        uploadNewObj.height = uploadObj?.height;
        uploadNewObj.width = uploadObj?.width;
        uploadNewObj.imageToVideo = true;
        // AUploadIpvSafari(videoUploaded, uploadObj);
      } else {
        // AUploadIpv(videoUploaded, uploadObj);
      }
      AUploadIpvNew(videoUploaded, uploadNewObj);
    } else {
      setsShowBrowserPermissionModal(true);
    }
  }

  function videoUploaded(res: any) {
    if (!res || res.error) {
      setIsLoading(false);
      // setErrCode("980 - Error in uploading video");
      gtmService({ action: "UploadIPVMerge", label: "ERROR || ERR151" });
      setErrCode(res.error);
      mixpanelService({
        event: mixpanelEvents.ERROR_TRIGGERED,
        screen_name: getScreenName(window.location.pathname),
        error_object: res.error,
      });
    } else {
      if (res.data) {
        saveIpvDetails({ coords: {} });
        // completeModuleStatus(dashboardUrl.ipv);
        // gtmService({ action: "VIDEO_IPV", label: "Step_Complete" });
        // // Clevertap event: submit documents data
        // const data = {
        //   EventName: cleverTapEvents.registration.ipvPage.CLICK_ON_SUBMIT,
        //   InitiationPlatform: "",
        //   UTM_SOURCE: UTM_SOURCE || "",
        //   UTM_MEDIUM: UTM_MEDIUM || "",
        //   UTM_CAMPAIGN: UTM_CAMPAIGN || "",
        //   KRA: GlobalStore.isKRA,
        //   DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
        //   ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
        //   LEAD_ID: GlobalStore.leadId,
        //   REF_ID: GlobalStore.applicationID,
        // };

        // ClevertapService.pushEvent(data);
        // // Clevertap ends here

        // // Apps flyer event for click on proceed on bank details page
        // AppsFlyerService.pushEvent(
        //   appsFlyerEvents.registration.ipvPage.CLICK_ON_SUBMIT
        // );

        // if (!id) history.push(incompleteStageNavigation());
        // else
        //   alert(
        //     "IPV uploaded successfully, please close this browser window and continue with your Account Opening process"
        //   );
      } else {
        setIsLoading(false);
        setErrCode("981 - Error in uploading video");
        gtmService({ action: "UploadIPVMerge", label: "ERROR || ERR151-S" });
        mixpanelService({
          event: mixpanelEvents.ERROR_TRIGGERED,
          screen_name: getScreenName(window.location.pathname),
          error_object: "981 - Error in uploading video",
        });
      }
    }
  }

  const sendSms = (val: string) => {
    console.log("lat", lat);
    console.log("long", long);
    if (lat !== "" && lat !== undefined && long !== "" && long !== undefined) {
      if (enableLink === true) {
        setEnableLink(false);
      } else {
        setEnableLink(true);
        // Create and send link for capturing IPV from mobile
        let AccountObj = {
          PanNo: GlobalStore?.personaldetails?.pan,
          AccountCategory: GlobalStore?.accountcategory
            ? GlobalStore?.accountcategory
            : GlobalStore?.stageStatus?.accountcategory,
          userid: userId,
        };
        let accountObjString = JSON.stringify(AccountObj);
        const encodedPan = btoa(accountObjString);
        const stringParams = `ipvLink?id=${encodedPan}`;
        const ipvUrl = `${config.root}${stringParams}`;

        console.log(ipvUrl);
        const smsBody = {
          mobNo: GlobalStore.user.mobile,
          selfieLinkText: ipvUrl,
          // selfieLinkText: `Give a Smile and complete your IPV process for Online Account Opening, click here ${ipvUrl} to complete the process. Regards, Nuvama`,
        };
        ASendSms(() => { }, smsBody);

        const ipvObj = {
          leadid: GlobalStore.leadId,
          clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
          applicationid: GlobalStore.applicationID,
          placeofDeclaration: "mumbai",
          empName: "diy user",
          designation: "online rm",
          branch: "mumbai",
          empCode: "0",
          organization: "Nuvama Wealth & investment Ltd",
          organizationCode: "2",
          geo_location: `${lat}, ${long}`,
          ipaddress: "192.168.200.80",
          ipvlink: ipvUrl,
          latitude: `${lat}`,
          longitude: `${long}`,
          source: "VideoVerification 2",
          createdBy: parseInt(userId),
        };
        console.log("called here in send SMS");
        //ASaveIPVerificationDetails(iPVerificationSaved, ipvObj);
        ASaveIPVerificationDetails(
          (response: any) => iPVerificationSaved(response, "fromSMS"),
          ipvObj
        );
      }
    } else {
      setsShowBrowserPermissionModal(true);
    }
  };

  function checkPdStatus() {
    const timer = setInterval(() => {
      AGetStageCompletionStatus(
        getClientStageDetails,
        GlobalStore.applicationID
      );
    }, 10000);
    intervalTimer = timer;
  }

  function getClientStageDetails(res: any) {
    if (!res || res.error) {
    } else if (res.data) {
      const responseObj = JSON.parse(res.data);
      if (!responseObj?.iskra && !responseObj?.isdigilockercompleted) {
        setStageData(responseObj);
        if (responseObj.isesigncompleted) {
          setIsLoading(false);
          console.log("Esign Completed");
          setESignCompleted(true);
        } else if (responseObj.isipvarificationcompleted) {
          setIsLoading(false);
          clearInterval(intervalTimer);
          // history.push(incompleteStageNavigation());
          if (!id)
            // history.push(dashboardUrl.profiler);
            navigate(dashboardUrl.profiler)
        }
      } else {
        window.location.reload();
      }
    }
  }
  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
    }
    return disabled;
  };

  useEffect(() => {
    if (window.location.pathname == "/ipvLink") {
      return;
    }
    AGetStageCompletionStatus(
      (res: any) => getClientStageDetails(res),
      GlobalStore.applicationID
    );
  }, [GlobalStore.applicationID])

  return (
    <>
      <div className="mgt40">
        <div className="fieldLblRight">
          <div className="explain">
            {showBrowserPermissionModal && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                  <div className="explainInfo w-100">
                    <p>
                      To open your account online, we would mandatorily need
                      access to your geo locations and camera. In your browser
                      notification, click on 'Allow' to proceed ahead
                    </p>
                  </div>
                  <div>
                    <Button
                      btnName="OK"
                      onClick={() => {
                        setsShowBrowserPermissionModal(false);
                        turnOnCamera();
                        // setsShowBrowserPermissionModal(false);
                      }}
                    />
                    {/* OK
                    </Button> */}
                  </div>
                </InfoModal>
              </div>
            )}
          </div>
        </div>
      </div>
      <Backdrop
        isCloseIcon={false}
        isShow={showSample}
        parentClassName={`bgColor ${DeviceContext()?.isMobile ? "backDropWidth" : ""}`}
        ariaLabel="Video Verification Sample Guide"
      // onClose={() => setShowSample(false)}
      >
        <div className="ipvDemo">
          <div className="ipv-title-row">
            <span className="title">For video verification:</span>

            <button
              type="button"
              aria-label="Close"
              onClick={() => {
                try {
                  const screen_name = getScreenName(window.location.pathname);
                  if (screen_name) {
                    mixpanelService({
                      event: mixpanelEvents.CTA_CLICKED,
                      screen_name,
                      text: "Close",
                      cta_type: "sticky",
                      cta_class: "secondary",
                      cta_service: "AOJ",
                    });
                  }
                } catch (e) {
                  console.error("mixpanel cta_clicked failed", e);
                }
                setShowSample(false);
              }}
              className="edel-icon-close"
            ></button>
          </div>
          <p className="Aadhar-format-read-more-new">
            Hold a paper with a number written on it in front of the camera and
            start recording.
          </p>

          <div className="images-first-row">
            <div className="box">
              <div className="profile-container">
                <img
                  src={correctIPV}
                  alt="Correct video verification example"
                  className="profile-image-new"
                />
                <div className="checkmark">✔</div>
              </div>
              <p className="success">
                Use a white sheet
                <br /> to verify the number.
              </p>
            </div>

            <div className="box ml-10">
              <div className="container-main">
                {/* Backend Image */}
                <img
                  src={wrongIpvOne}
                  alt="Incorrect video verification example"
                  height={120}
                  width={120}
                  className="image-new"
                />

                {/* Cross Button */}
                <span className="crossButton">
                  <i className="edel-icon-close" aria-hidden="true" />
                </span>
              </div>
              {/* <img src={wrongIpvOne} alt="Incorrect video verification example" height={80} width={120} /> */}
              <p className="error">
                {" "}
                Don’t clutter the frame
                <br /> with objects or people.
              </p>
            </div>
          </div>

          <div className="images-first-second">
            <div className="box ml-10-new">
              <div className="container-main">
                {/* Backend Image */}
                <img
                  src={wrongIpvTwo}
                  alt="Incorrect video verification example"
                  height={120}
                  width={120}
                  className="image-new"
                />

                {/* Cross Button */}
                <span className="crossButton">
                  <i className="edel-icon-close" aria-hidden="true" />
                </span>
              </div>
              <p className="error">
                {" "}
                Don’t cover your face
                <br /> with verification sheet.{" "}
              </p>
            </div>

            <div className="box ml-30">
              <div className="container-main">
                {/* Backend Image */}
                <img
                  src={wrongIpvThree}
                  alt="Incorrect video verification example"
                  height={120}
                  width={120}
                  className="image-new"
                />

                {/* Cross Button */}
                <span className="crossButton">
                  <i className="edel-icon-close" aria-hidden="true" />
                </span>
              </div>
              <p className="error">
                {" "}
                Don’t record a blurry/
                <br />
                dark video.
              </p>
            </div>
          </div>
          <p className="below-text-more-new">
            Note: Ensure to enable location and camera access.
          </p>
          {/* <img className="ipvDemoImg" src={ipvDemo} alt="ipvDemo" />
          <div className="ipvDemoInfo">
            <h2 className="heading">Video Verification</h2>
            <label className="info">
              Write down the OTP on a white paper and hold it in front of the
              camera.
            </label>
          </div> */}
        </div>
      </Backdrop>
      <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
        {isLoading ? "Loading, please wait…" : ""}
      </span>
      <fieldset disabled={isLoading}>
        <legend className="sr-only">Video verification</legend>
        <div
          className={
            "ipvHome" +
            (isLoading ? " op05" : "") +
            (id ? "" : " ml100") +
            (eSignCompleted ? " readOnly" : "")
          }
        >
          <h2 className="ipvHeading">Video Verification</h2>
          <p className="ipvInfo">
            Write down the OTP given below on a white paper and hold it in front
            of the camera.
          </p>
          <button
            type="button"
            className="ipvSample"
            onClick={() => {
              try {
                const screen_name = getScreenName(window.location.pathname);
                if (screen_name) {
                  mixpanelService({
                    event: mixpanelEvents.CTA_CLICKED,
                    screen_name,
                    text: "View Sample",
                    cta_type: "sticky",
                    cta_class: "secondary",
                    cta_service: "AOJ",
                  });
                }
              } catch (e) {
                console.error("mixpanel cta_clicked failed", e);
              }
              setShowSample(true);
            }}
          >
            View Sample
          </button>
          <div className="ipvOtp">
            <span className="ipvOtpVal">{otp}</span>
          </div>
          {otp && (
            <div className="ipvVideoPlayer">
              <VideoPlayerIpv
                ipvUploaded={ipvUploaded}
                isGeoError={showBrowserPermissionModal}
                isLocationPermission={locationPermission}
                checkGeoLocation={getLocation}
                lat={lat}
                long={long}
              />
            </div>
          )}

          {isGeoError && !isGeoErrorTimeFlag ? (
            <>
              <div className="geoErrorMsg">
                <p>
                  {" "}
                  There is a delay in loading the contents, please wait for a
                  moment !!
                </p>
              </div>
            </>
          ) : null}

          {isGeoError && isGeoErrorTimeFlag ? (
            <>
              <div className="geoErrorMsg">
                <p>
                  {" "}
                  There was a delay in loading the contents, refresh the page!!{" "}
                </p>
              </div>
            </>
          ) : null}

          {!id && (
            <div className="togContainer mrt40">
              <label className="isTogLabel" htmlFor="ipv-send-link-toggle">
                Send link to capture IPV on Mobile
              </label>
              <div className="togSize">
                <Toggle
                  id="ipv-send-link-toggle"
                  isOn={enableLink}
                  onChange={() => sendSms("Photo")}
                  disabled={shouldDisable()}
                  ariaLabel="Send link to capture IPV on Mobile"
                />
              </div>
            </div>
          )}
          <div>
            {enableLink && (
              <div className="watsLayout">
                <span className="shareDoc">
                  You will receive a link on Mobile. Once uploaded, we will take
                  you to the next step.
                </span>
                {/* <div className="watsNum">
                                    <label className="watsapp">WhatsApp</label>
                                    <br />
                                    <label className="watsAppNum">
                                        <span>
                                            <img className="watsappImg" src={watsAppIcon} alt="" aria-hidden="true" />
                                        </span>
                                        {watsappNo}
                                    </label>
                                </div> */}
              </div>
            )}
          </div>
          {/* Error Msg Start*/}
          {errCode && (
            <div className="errMsgBlck">
              <ErrMsg>
                {typeof errCode === "number" ? (
                  <>
                    <span>We are facing some technical issue.</span>
                    <span>
                      Please try after sometime (error code:{errCode})
                    </span>
                  </>
                ) : (
                  <span>{errCode}</span>
                )}
              </ErrMsg>
            </div>
          )}
          {/* Error Msg End*/}
        </div>
      </fieldset>
    </>
  );
};

export default VideoVerification;
